/**
 * TutorialsSettingsSection — Tutorials sub-screen body.
 * Web port of client-native TutorialsSettingsScreen.tsx: Video Tutorial
 * (showWordTutorialNextLesson) + Feed Demo (showFeedTutorialNextLesson). Copy
 * matches iOS verbatim.
 *
 * iOS also has an "Onboarding Checklist" toggle (binds isTutorialDismissed) as
 * the first row, but it is intentionally OMITTED on web: the web onboarding
 * checklist UI isn't mounted in the home shell, so the toggle would be
 * functionally inert (toggling it would change nothing visible). Per the project
 * rule that buttons must obviously work, we leave it out until the web checklist
 * feature ships.
 */
import { FC } from "react";
import { SettingsToggle } from "../SettingsToggle";
import { useSettingsToggle } from "./useSettingsToggle";

const TutorialsSettingsSection: FC = () => {
  const { settings, isLoading, toggle } = useSettingsToggle();

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <SettingsToggle
        label="Video Tutorial"
        isChecked={settings?.showWordTutorialNextLesson || false}
        onChange={() => toggle("showWordTutorialNextLesson")}
        isDisabled={isLoading}
        helpContent={
          <div>
            <p>
              <strong>Video Tutorial</strong>
            </p>
            <p>
              Show the interactive tutorial on your next video lesson that
              teaches you how to tap words and highlight phrases.
            </p>
          </div>
        }
      />
      <SettingsToggle
        label="Feed Demo"
        isChecked={settings?.showFeedTutorialNextLesson || false}
        onChange={() => toggle("showFeedTutorialNextLesson")}
        isDisabled={isLoading}
        helpContent={
          <div>
            <p>
              <strong>Feed Demo</strong>
            </p>
            <p>
              Show tutorial demonstrations for navigating the video feed on your
              next feed visit.
            </p>
          </div>
        }
      />
    </div>
  );
};

export default TutorialsSettingsSection;
